const input = "_35siib6h6j";

export { input };
import "./input.richtext.style.linaria.module.css";
//# sourceMappingURL=input.richtext.style.js.map
